export class CentroDeResultados {
  Id: number;
  Codigo:string = "";
  Descricao:string = "";
  CodigoPai: number = 0;
  IsAnalitico: boolean;

  _codigo: number = 0;
}
